<template>
  <v-app  :dark="!light" :light="light">
    <v-toolbar app color="primary" :extended="!!user" extension-height="56px">
      <v-avatar @click="getLocation">
        <v-img :src="require('./assets/pwa-logo-48.png')">
        </v-img>
      </v-avatar>
      <v-toolbar-title class="subheading text-uppercase white--text">
        <span>VERDE SMART DATA</span>
        <br>
        <span class="font-weight-light">Verde Scoli</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="light = !light" small>
        <v-icon :color="light ? 'yellow lighten-3' : 'blue-grey lighten-3'">
          {{light ? 'mdi-lightbulb-on' : 'mdi-lightbulb'}}
        </v-icon>
      </v-btn>

      <v-btn @click="_cbRefreshWindow" icon :ripple="false">
        <v-icon color="white">mdi-reload-alert</v-icon>
      </v-btn>

      <v-btn @click="_cbReloadWorker" v-if="user" icon :ripple="false">
        <v-icon color="white">mdi-worker</v-icon>
      </v-btn>

      <v-btn @click="_cbRefresh" v-if="user && refreshCount" icon :ripple="false">
        <!-- <v-badge overlap color="transparent">
          <template v-slot:badge>
            <span class="caption">{{ refreshCount }}</span>
          </template>
          <v-icon color="white">mdi-refresh</v-icon>
        </v-badge> -->
        <v-icon color="warning">mdi-refresh</v-icon>
      </v-btn>

      <v-btn icon @click="_cbLogout" v-if="user" class="white--text" :ripple="false">
        <v-icon>mdi-logout</v-icon>
      </v-btn>

      <template v-slot:extension v-if="!!user">
        <div style="width: 100%">
          <v-progress-linear height="36" color="accent" class="my-0" :value="progress">
            <div class="pl-2 white--text" style="display: flex; align-items: center; justify-content: space-between; height: 100%">
              <v-btn icon @click="openDeleteSheet" :disabled="!filesCount" class="ma-0" :ripple="false">
                <v-icon color="deep-orange lighten-3">mdi-delete</v-icon>
              </v-btn>
              <v-btn  class="mr-2" @click="_cbToggleMessages" icon :disbaled="!filesCount" :ripple="false">
                <v-icon  color="white">mdi-message-alert</v-icon>
              </v-btn>
              <span class="caption">{{filesDone}} din {{filesCount}} fisiere ({{filesSize}})</span>
              <v-icon :color="online === 'on' ? 'white' : online === 'off' ? 'red' : 'deep-orange accent-1'" >
                <template v-if="online === 'on'">mdi-wifi-strength-4</template>
                <template v-else-if="online === 'off'">mdi-wifi-strength-off</template>
                <template v-else>mdi-wifi-strength-4-alert</template>
              </v-icon>
              <v-btn icon @click="startUpload" :disabled="!filesCount" class="ma-0" v-if="workerStop" :ripple="false">
                <v-icon color="white" >mdi-cloud-upload</v-icon>
              </v-btn>
              <v-btn icon @click="pauseUpload" class="ma-0" v-else :ripple="false">
                <v-icon color="white" >mdi-pause</v-icon>
              </v-btn>
            </div>
          </v-progress-linear>

          <v-progress-linear height="2" color="yellow" class="my-0" :value="progressOne">
          </v-progress-linear>
        </div>
      </template>
    </v-toolbar>

    <v-content>
      <!-- <transition :name="transitionName" mode="out-in"> -->
        <router-view/>
      <!-- </transition> -->
    </v-content>

    <v-bottom-nav :value="!!user" app :color="light ? 'white' : 'grey darken-4 white--text'" :light="light">
      <!-- <v-btn flat color="primary" to="/" :ripple="false">
        <span>Acasa</span>
        <v-icon>mdi-home</v-icon>
      </v-btn> -->
      <v-btn flat color="primary" to="/entities" :ripple="false">
        <span>Simboluri</span>
        <v-icon>mdi-map-marker-radius</v-icon>
      </v-btn>
      <v-btn flat color="primary" to="/map" :ripple="false">
        <span>Harta</span>
        <v-icon>mdi-map</v-icon>
      </v-btn>
      <v-btn flat color="primary" to="/photos" :ripple="false">
        <span>Poze</span>
        <v-icon>mdi-image-multiple</v-icon>
      </v-btn>
      <v-btn flat color="primary" to="/dashboard" v-if="user && user.admin" :ripple="false">
        <span>Dashboard</span>
        <v-icon>mdi-desktop-mac-dashboard</v-icon>
      </v-btn>
    </v-bottom-nav>

    <v-bottom-sheet v-model="deleteSheet" hide-overlay>
      <v-list three-line dense style="max-height: 35vh; overflow-y: auto">
        <v-subheader>Elimina fisiere din lista de asteptare:</v-subheader>
        <v-list-tile
          v-for="file in files"
          :key="file.id">
          <v-list-tile-action style="color: grey">
            <v-icon small :color="file.tip === 'photo' ? 'primary' : 'error'">
              {{ file.tip === 'photo' ? 'mdi-camera' : 'mdi-file-pdf' }}
            </v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              {{ file.name }}
            </v-list-tile-title>
            <v-list-tile-sub-title>
              {{ prettyB(file.size) }}
              {{ (new Date(file.lastModified)).toLocaleString('ro-RO') }}
            </v-list-tile-sub-title>
            <v-list-tile-sub-title>
              <v-chip outline small>{{file.parent}}</v-chip>
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action @click="removeRef(file)">
            <v-btn icon v-if="!file.uploaded" :ripple="false">
              <v-icon color="error">mdi-delete</v-icon>
            </v-btn>
            <v-icon color="primary" v-else>mdi-check</v-icon>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-bottom-sheet>

    <v-bottom-sheet v-model="messagesOpen" hide-overlay>
      <v-list dense three-line style="max-height: 35vh; overflow-y: auto">
        <v-subheader style="disdplay_flex; justify-content: space-between">
          Notificari si mesaje (ultimele 20)
          <v-spacer></v-spacer>
          <v-btn small icon @click="_cbClearMessages" :ripple="false">
            <v-icon small color="error">mdi-delete-sweep</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn small icon @click="_cbToggleMessages" :ripple="false">
            <v-icon small color="error">mdi-close</v-icon>
          </v-btn>
        </v-subheader>
        <v-list-tile
          v-for="message in messages"
          :key="message.id">
          <v-list-tile-action>
            <v-icon :color="message.type === 'fail' ? 'error' : 'success'">
              {{ getMessageIcon(message) }}
            </v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              {{ message.timestamp.toLocaleDateString('ro-RO', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit'}) }}
            </v-list-tile-title>
            <v-list-tile-sub-title>
              {{ message.text}}
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-icon color="error" @click="_cbDeleteMessage(message.id)">
              mdi-delete
            </v-icon>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-bottom-sheet>
  </v-app>
</template>

<script>

import prettyBytes from 'pretty-bytes'
export default {
  name: 'App',
  data () {
    return {
      transitionName: 'slide-x-transition',
      deleteSheet: false
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    loading () {
      return this.$store.getters.loading
    },
    light: {
      get () {
        return this.$store.getters.light
      },
      set (value) {
        this.$store.commit('setLight', value)
      }
    },
    online () {
      return this.$store.getters.online
    },
    files () {
      return this.$store.getters['entities/files']
    },
    filesCount () {
      return this.$store.getters['entities/filesCount']
    },
    filesSize () {
      return this.$store.getters['entities/filesSize']
    },
    filesDone () {
      return this.$store.getters['entities/filesDone']
    },
    progress () {
      return this.filesCount ? this.filesDone * 100 / this.filesCount : 0
    },
    progressOne () {
      return this.$store.getters['entities/progressOne']
    },
    workerStop () {
      return this.$store.getters['entities/workerStop']
    },
    messages () {
      return this.$store.getters.messages
    },
    messagesOpen: {
      get () {
        return this.$store.getters.messagesOpen
      },
      set (value) {
        this.$store.commit('setMessagesOpen', value)
      }
    },
    isDetailsEdited () {
      return this.$store.getters.isDetailsEdited
    },
    refreshCount () {
      return this.$store.getters.refreshCount
    }
  },
  watch: {
    filesCount (val) {
      if (!val && this.deleteSheet) this.deleteSheet = false
    },
    $route (to, from) {

    }
  },
  methods: {
    prettyB (size) {
      return prettyBytes(size)
    },
    _cbLogout () {
      this.$dialog
        .confirm({
          title: 'Vreti sa va inchideti seisunea de lucru?',
          body: 'Daca inchideti sesiunea de lucru va trebui sa va reautentificati!'
        }, {
          okText: 'DA, inchid!',
          cancelText: 'Nu, raman!',
          animation: 'zoom'
        }, { animation: 'bounce' })
        .then(dialog => {
          this.$store.dispatch('logout')
            .then(res => {
              this.$router.push({ name: 'login' })
            })
            .catch(err => {
              console.log('err', err)
              this.$router.push({ name: 'login' })
            })
        })
        .catch(() => {

        })
    },
    getLocation () {
      if (this.user) {
        this.$store.dispatch('getLocation')
      }
    },
    async startUpload () {
      if (this.$router.currentRoute && this.$router.currentRoute.name === 'details') {
        // i really really really don't like this
        // this.$children[0].$children[1].$children[0].isEdited
        if (this.isDetailsEdited) {
          try {
            await this.$dialog
              .confirm({
                title: 'Atentie!',
                body: 'Daca vei porni upload-ul, vei pierde modificarile nesalvate! Doresti sa continui?'
              }, {
                okText: 'DA',
                cancelText: 'Nu',
                animation: 'zoom'
              })
          } catch (e) {
            return
          }
        }
      }

      if (this.online === 'lie-fi') {
        this.$dialog
          .confirm({
            title: 'Atentie!',
            body: 'Conexiunea la Internet este de tip LIE-FI (cea mai simpla comunicare cu serverul dureaza mai mult de 5 secunde). Esti sigur ca vrei sa incerci upload-ul?'
          }, {
            okText: 'DA',
            cancelText: 'Nu, incerc mai tarziu!',
            animation: 'zoom'
          })
          .then(dialog => {
            this.$store.dispatch('entities/uploadPhotos')
          })
          .catch(() => {})
      } else {
        this.$store.dispatch('entities/uploadPhotos')
      }
      this.$store.dispatch('entities/uploadPhotos')
    },
    openDeleteSheet () {
      this.deleteSheet = true
    },
    removeRef (file) {
      if (!file.uploaded) this.$store.commit('entities/removeFile', file)
    },
    pauseUpload () {
      this.$store.dispatch('entities/pauseUpload')
    },
    _cbToggleMessages () {
      this.messagesOpen = !this.messagesOpen
    },
    _cbDeleteMessage (id) {
      this.$store.commit('deleteMessage', id)
    },
    _cbClearMessages () {
      this.$store.commit('deleteAllMessages')
    },

    getMessageIcon (message) {
      switch (message.tip) {
        case 'photo': return 'mdi-camera'
        case 'pdf': return 'mdi-file-pdf'
        case 'test': return 'mdi-speedometer'
        case 'error': return 'mdi-alert-circle'
        case 'success': return 'mdi-check-circle'
      }
    },
    async _cbRefresh () {
      if (this.$router.currentRoute && this.$router.currentRoute.name === 'details') {
        // i really really really don't like this
        // this.$children[0].$children[1].$children[0].isEdited
        if (this.isDetailsEdited) {
          try {
            await this.$dialog
              .confirm({
                title: 'Atentie!',
                body: 'Daca vei "face refresh", vei pierde modificarile nesalvate! Doresti sa continui?'
              }, {
                okText: 'DA',
                cancelText: 'Nu',
                animation: 'zoom'
              })
          } catch (e) {
            return
          }
        }
      }

      this.$store.dispatch('entities/fetchEntities')
      // this.$store.dispatch('entities/fetchAllEntities')
      this.$store.dispatch('entities/setActiveEntity')
    },
    async _cbReloadWorker () {
      try {
        await this.$dialog
          .confirm({
            title: 'Atentie!',
            body: 'Esti sigur ca vrei sa reincarci modulul de upload?'
          }, {
            okText: 'DA',
            cancelText: 'Nu',
            animation: 'zoom'
          })
      } catch (e) {
        return
      }
      this.$store.dispatch('entities/setupWorker')
    },
    async _cbRefreshWindow () {
      try {
        await this.$dialog
          .confirm({
            title: 'Atentie!',
            body: 'Esti sigur ca vrei sa reincarci toata aplicatia?'
          }, {
            okText: 'DA',
            cancelText: 'Nu',
            animation: 'zoom'
          })
      } catch (e) {
        return
      }
      window.location.reload()
    }

    // handleVisibilityChange () {
    //   console.log(document.hidden)
    // }
  },
  mounted () {
    // document.addEventListener('visibilitychange', this.handleVisibilityChange, false)
    this.$store.dispatch('setOnlineOfflineHandler')
  }
}
</script>

<style lang="stylus">

.data-loading {
  animation-name: loading
  animation-duration: 1.5s
  animation-timing-function: ease-out
  animation-delay: 0s
  animation-direction: alternate
  animation-iteration-count: infinite
  animation-fill-mode: none
  animation-play-state: running
}

@keyframes loading {
  from {
    opacity: 1
  }
  to {
    opacity: 0.2
  }
}

.fadeTr-enter-active {
  transition: none !important;
}
.fadeTr-leave-active {
  transition: none !important;
}
.fadeTr-enter, .fadeTr-leave-to {
  opacity: 0;
}
.slide-enter-active,
.slide-leave-active {
  transition: none !important;
}
.slide-enter,
.slide-leave-to {
  opacity: 0;
  -webkit-transform: translateX(30px);
          transform: translateX(30px);
}
.dg-backdrop-enter-active {
  animation: none !important;
}
.dg-backdrop-leave-active {
  animation: none !important;
}
.dg-fade-enter-active {
  animation: none !important;
}
.dg-fade-leave-active {
  animation: none !important;
}

.dg-zoom-enter-active {
  animation: none !important;
}
.dg-zoom-leave-active {
  animation: none !important;
}

.dg-bounce-enter-active {
  animation: none !important;
}
.dg-bounce-leave-active {
  animation: none !important;
}

.v-tabs__item--active {
  color: var(--v-accent-base) !important;
}

.dg-btn {
  border: none !important;
  font-family:Roboto, sans-serif;
  font-size:14px;
  font-stretch:100%;
  font-style:normal;
  font-variant-caps:normal;
  font-variant-east-asian:normal;
  font-variant-ligatures:normal;
  font-variant-numeric:normal;
  font-weight:500;
  -webkit-font-smoothing:antialiased;
  text-align:center;
  text-indent:0px;
  text-rendering:auto;
  text-shadow:none;
  text-size-adjust:100%;
  text-transform:uppercase;
}
.dg-btn--ok {
  // verde
  color: var(--v-primary-base) !important;
}
.dg-btn--cancel {
  // rosu
  background-color: transparent !important;
  color: var(--v-error-base) !important;
}

details {
    border-radius: 4px;
    padding: .5em .5em 0;
}

summary {
    font-weight: bold;
    margin: -.5em -.5em 0;
    padding: .5em;
    outline: none;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    min-height: 50px;
    align-items: center;
}

details[open], details[open] summary {
    padding: .5em;
    // margin-bottom: .5em;
}

details[open] div::first-of-type {
    // border-bottom: 1px solid #aaa;
    margin-bottom: .5em;
    padding-left: 1em;
}

// details input, details textarea, details summary.editable {
//   color: var(--v-accent-base) !important;
// }
details summary:not(.editable) {
  color: #999 !important;
}

.deletePhoto, .deletePdf {
  border: 1px solid var(--v-error-base) !important;
}

.badPhoto {
  border: 1px solid var(--v-warning-base) !important;
}

.normalPhoto, .normalPdf {
  border: 1px dashed var(--v-primary-base) !important;
}

.viewerPhoto {
  border: 1px solid var(--v-primary-base) !important;
}

.changelog p {
  text-align: justify;
}
</style>
